// src/FeaturesSection.js
import React from 'react';

const FeaturesSection = () => {
  return (
    <section
      style={{
        padding: '1rem 0', // 16px top and bottom padding (py-16)
        color: 'white',
        textAlign: 'center',
      }}
      data-aos="fade-up"
    >
      <h2
        style={{
          fontSize: 'clamp(0.75rem, 4vw, 2.5rem)', // Reduced font size
          fontWeight: 'bold',
          marginBottom: '0.5rem', // mb-8
        }}
      >
        Why Learn With Us?
      </h2>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
        }}
        data-aos-delay="100"
      >
        {/* Card 1 */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1rem',
            margin: '0.5rem',
            borderRadius: '0.5rem',
            width: '100%',
            maxWidth: '300px',
            backgroundColor: '#2d2d2d', // bg-gray-800
            border: '2px solid #ff7c0a', // border-orange-400
            color: 'white',
            transform: 'scale(1)',
            transition: 'transform 0.3s, box-shadow 0.3s, border-color 0.3s',
          }}
          className="card"
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/🦆 emoji _woman teacher_.svg`}
            alt="🦆 emoji"
            style={{
              marginBottom: '1rem',
              width: '4rem', // w-16
              height: '4rem', // h-16
            }}
          />
          <h3
            style={{
              fontSize: 'clamp(1.25rem, 4vw, 2rem)',
              fontWeight: 'bold',
              marginBottom: '0.5rem',
            }}
          >
            Expert Instructors
          </h3>
          <p
            style={{
              fontSize: 'clamp(0.875rem, 3vw, 1.125rem)',
            }}
          >
            Learn from the best in the industry.
          </p>
        </div>

        {/* Card 2 */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1rem',
            margin: '0.5rem',
            borderRadius: '0.5rem',
            width: '100%',
            maxWidth: '300px',
            backgroundColor: '#2d2d2d', // bg-gray-800
            border: '2px solid #ff7c0a', // border-orange-400
            color: 'white',
            transform: 'scale(1)',
            transition: 'transform 0.3s, box-shadow 0.3s, border-color 0.3s',
          }}
          className="card"
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/🦆 illustration _E-learning education online school courses_.svg`}
            alt="🦆 illustration _E-learning education online school courses_"
            style={{
              marginBottom: '1rem',
              width: '4rem', // w-16
              height: '4rem', // h-16
            }}
          />
          <h3
            style={{
              fontSize: 'clamp(1.25rem, 4vw, 2rem)',
              fontWeight: 'bold',
              marginBottom: '0.5rem',
            }}
          >
            Comprehensive Courses
          </h3>
          <p
            style={{
              fontSize: 'clamp(0.875rem, 3vw, 1.125rem)',
            }}
          >
            Courses that cover all aspects of the Igbo language.
          </p>
        </div>

        {/* Card 3 */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1rem',
            margin: '0.5rem',
            borderRadius: '0.5rem',
            width: '100%',
            maxWidth: '300px',
            backgroundColor: '#2d2d2d', // bg-gray-800
            border: '2px solid #ff7c0a', // border-orange-400
            color: 'white',
            transform: 'scale(1)',
            transition: 'transform 0.3s, box-shadow 0.3s, border-color 0.3s',
          }}
          className="card"
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/🦆 illustration _User Group_.svg`}
            alt="🦆 illustration _User Group_"
            style={{
              marginBottom: '1rem',
              width: '4rem', // w-16
              height: '4rem', // h-16
            }}
          />
          <h3
            style={{
              fontSize: 'clamp(1.25rem, 4vw, 2rem)',
              fontWeight: 'bold',
              marginBottom: '0.5rem',
            }}
          >
            Community Support
          </h3>
          <p
            style={{
              fontSize: 'clamp(0.875rem, 3vw, 1.125rem)',
            }}
          >
            Join a community of learners and get support.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;